import { render } from "./AddSubject.vue?vue&type=template&id=449b93e4"
import script from "./AddSubject.vue?vue&type=script&lang=js"
export * from "./AddSubject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__